import firebase from "firebase";
import Vue from "vue";
import VueRouter from "vue-router";

import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import Signup from "../views/SignUp.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    redirect: "/login"
  },
  {
    path: "/",
    redirect: "/login"
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      title: "vue Firebase Test Login"
    }
  },
  {
    path: "/sign-up",
    name: "Signup",
    component: Signup,
    meta: {
      title: "vue Firebase Test Signup"
    }
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    meta: {
      title: "vue Firebase Test Homepage",
      requiresAuth: true
    }
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach((to,from,next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  document.title = to.meta.title || "vue Firebase Test Project";

  if (requiresAuth && !currentUser) next("login");
  else if (!requiresAuth && currentUser) next("home");
  else next();
});

export default router;
